import React from 'react';
import PropTypes from 'prop-types';

import { calculateFilterColor } from '@/utils/Common/ListingUtils';

const FilterColor = ({ value, onChange }) => {
  const { name, style } = calculateFilterColor(value.code);
  return (
    <div className='bra-radio'>
      <input
        id={`toolbarPlpCheckbox-${name}`}
        className='bra-radio__input'
        type='checkbox'
        checked={value.selected}
        onChange={() => onChange(value.query)}
      />
      <span className='bra-radio__placeholder' style={style} />
      <label
        htmlFor={`toolbarPlpCheckbox-${name}`}
        className='bra-radio__label'
      >
        {name} <span>({value.count})</span>
      </label>
    </div>
  );
};

FilterColor.propTypes = {
  value: PropTypes.shape(),
  onChange: PropTypes.func,
};

FilterColor.defaultProps = {
  value: {},
  onChange: null,
};

export default FilterColor;
